import { useCreateSortable } from '../../../hooks/sortable';
import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { useEffect } from 'react';
import { Sorter } from '../../../models/sorter';
export function useCreateSorter(ref, options) {
  var _options$mode = options.mode,
      mode = _options$mode === void 0 ? 'horizontal' : _options$mode,
      hittingContainerClassName = options.hittingContainerClassName,
      renderPlaceHolder = options.renderPlaceHolder,
      onDraggingChange = options.onDraggingChange;
  var sorter = useSingleton(function () {
    return new Sorter();
  });
  var onDraggingChangeCallback = useRefCallback(onDraggingChange);
  var sortable = useCreateSortable({
    mode: mode,
    hittingContainerClassName: hittingContainerClassName,
    createPlaceHolder: function createPlaceHolder(id, index, e) {
      return renderPlaceHolder({
        container: id,
        index: index,
        target: e.target,
        data: e.data
      });
    },
    getDragRoot: function getDragRoot() {
      return ref.current;
    },
    getContainerMode: function getContainerMode(id) {
      return sorter.getContainerMode(id);
    },
    onChange: function onChange(e, from, to) {
      return sorter.setSorter(from, to);
    },
    isValidContainer: function isValidContainer(data, id) {
      return sorter.isValidContainer(data, id);
    },
    onDragStart: function onDragStart(e) {
      return sorter.setDragging(true, e.data);
    },
    onDragCancel: function onDragCancel() {
      return sorter.setDragging(false);
    },
    onDragEnd: function onDragEnd() {
      return sorter.setDragging(false);
    }
  });
  useEffect(function () {
    sorter.addListener('dragging-change', onDraggingChangeCallback);
    return function () {
      sorter.removeListener('dragging-change', onDraggingChangeCallback);
    };
  }, []);
  return [sortable, sorter];
}